import { createRouter, createWebHashHistory } from "vue-router";

import DashboardLayout from "@/appViews/Layout/DashboardLayout";
import AuthLayout from "@/appViews/Layout/AuthLayout";

// MapletFSCloudのアプリビュー
import Signin from "../appViews/Signin.vue";
import Projects from "../appViews/Projects/Projects.vue";
import ProjectMain from "../appViews/Projects/ProjectMain.vue";
import ProjectEditor from "../appViews/Projects/ProjectEditor.vue";
import MakeUser from "@/appViews/User/MakeUser.vue";
import UserList from "@/appViews/User/UserList.vue";
import TenantManage from "@/appViews/NcsManage/TenantManage.vue";
import TenantEdit from "@/appViews/NcsManage/TenantEdit.vue";
import InspectMasterEdit from "@/appViews/InspectMaster/InspectMasterEdit.vue"
import InspectMasterList from "@/appViews/InspectMaster/InspectMasterList.vue"
import NoticeList from "@/appViews/Notice/NoticeList.vue"
import ForgotPassword from "@/appViews/User/ForgotPassword.vue";
import Maintenance from "@/appViews/Maintenance.vue";
import ProjectView from "@/appViews/Projects/ProjectView.vue";
import NotFound from "@/appViews/NotFound/NotFound.vue";

import { Auth } from "aws-amplify";
import AuthUtil from "../appUtils/AuthUtil"

const routes = [
  {
    path: "/userlist",
    component: DashboardLayout,
    children: [
      {
        path: "/userlist",
        name: "UserList",
        components: { default: UserList },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "ユーザー管理",
          hideFooter: true,
        },
      },
      {
        path: "/makeuser",
        name: "MakeUser",
        components: { default: MakeUser },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "ユーザー管理",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/edituser",
        name: "EditUser",
        components: { default: MakeUser },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "ユーザー管理",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/editusermodal",
        name: "EditUserModal",
        components: { default: MakeUser },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "ユーザ編集",
          hideFooter: true,
        },
        props: true,
      },
    ]
  },
  {
    path: "/Projects",
    component: DashboardLayout,
    children: [
      {
        path: "/Projects",
        name: "Projects",
        components: { default: Projects },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "プロジェクト",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/projectMain",
        name: "ProjectMain",
        components: { default: ProjectMain },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "プロジェクト",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/newproject",
        name: "NewProject",
        components: { default: ProjectEditor },
        meta: {
          navbarType: "light",
          isNewProject: 1,
          requiresAuth: true,
          title: "新規プロジェクト作成",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/editproject",
        name: "EditProject",
        components: { default: ProjectEditor },
        meta: {
          isNewProject: 0,
          navbarType: "light",
          requiresAuth: true,
          title: "プロジェクト編集",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/projectview",
        name: "ProjectView",
        components: { default: ProjectView },
        meta: {
          isNewProject: 0,
          navbarType: "light",
          requiresAuth: true,
          title: "プロジェクトビュー",
          hideFooter: true,
        },
        props: true,
      },
    ]
  },
  {
    path: "/inspectmasterlist",
    component: DashboardLayout,
    children: [
      {
        path: "/inspectmasterlist",
        name: "InspectMasterList",
        components: { default: InspectMasterList },
        meta: {
          isNewProject: 0,
          navbarType: "light",
          requiresAuth: true,
          title: "検査マスタ一覧",
          hideFooter: true,
        },
        props: true,
      },
      {
        path: "/inspectmasteredit",
        name: "InspectMasterEdit",
        components: { default: InspectMasterEdit },
        meta: {
          isNewProject: 0,
          navbarType: "light",
          requiresAuth: true,
          title: "検査マスタ編集",
          hideFooter: true,
        },
        props: true,
      },
    ]
  },
  {
    path: "/noticeList",
    component: DashboardLayout,
    children: [
      {
        path: "/noticeList",
        name: "NoticeList",
        components: { default: NoticeList },
        meta: {
          navbarType: "light",
          requiresAuth: true,
          title: "通知",
          hideFooter: true,
        },
      }
    ]
  },
  {
    path: "/tenantManage",
    component: DashboardLayout,
    children: [
      {
        path: "/tenantManage",
        name: "TenantManage",
        components: { default: TenantManage },
        meta: {
          isNewProject: 0,
          navbarType: "light",
          requiresAuth: true,
          ncsManager: true,
          title: "テナント管理",
          hideFooter: true,
        },
      },
      {
        path: "/tenantEdit",
        name: "TenantEdit",
        components: { default: TenantEdit },
        meta: {
          isNewProject: 0,
          navbarType: "light",
          requiresAuth: true,
          ncsManager: true,
          title: "テナント編集",
          hideFooter: true,
        },
      },
    ]
  },
  {
    path: "/",
    component: AuthLayout,
    children: [
      {
        path: "/",
        name: "Signin",
        components: { default: Signin },
        meta: {
          requiresAuth: false
        },
      },
      {
        path: "/forgotpassword",
        name: "ForgotPassword",
        components: { default: ForgotPassword },
        meta: {
          requiresAuth: false,
          title: "認証コードを送信",
        },
      },
      {
        path: "/maintenance",
        name: "Maintenance",
        components: { default: Maintenance },
        meta: {
          requiresAuth: false
        },
      }
    ],
  },
  {
    path: '/:catchAll(.*)',
    name: 'NotFound',
    component: NotFound
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: "active",
  routes,
});

// リダイレクト設定
router.beforeResolve(async (to, from, next) => {
  // セッション切れtest用
  
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // MCZユーザ専用画面の判定
    //const user = await getUser()
    try {
      
      // 認証済みであるか
      const data = await Auth.currentAuthenticatedUser();

      if (data && data.signInUserSession) {
        return next();
        
      } else {
        // 未認証であればルートパスへリダイレクト
        AuthUtil.alert();
        return next({
          path: "/",
        });
      }
    
    } catch (e) {
      // 例外発生時もルートパスへリダイレクトする
      AuthUtil.alert();
      return next({
        path: "/",
      });
    }
  }

  return next();
});

export default router;
